import { render } from "./MultipleChoice.vue?vue&type=template&id=dda5503e&scoped=true&ts=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"

import "./MultipleChoice.vue?vue&type=style&index=0&id=dda5503e&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda5503e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
